<template>
  <div class="row">
    <!-- <div class="col-md-12">
            <h1 class="h3 mb-3 text-gray-800">
                Programas Sociais: Família ID #{{ $route.params.id }}
            </h1>
        </div>
        <load v-if="loading" /> -->
    <header-servico
      tipo="Programas Sociais"
      :loading="loading"
      :familia="familia.id"
    />
    <load v-if="loading" message="Carregando Programas Sociais da Família" />
    <div v-else class="col-md-12">
      <div class="row">
        <sidebar-servicos active="programassociais" />
        <div class="col-md-9">
          <div class="row">
            <div class="col-md-12">
              <header-familia :item="familia" />
            </div>
          </div>
          <div class="card mb-0 shadow">
            <div class="card-body">
              <div class="tab-content">
                <div
                  v-if="!associar_programa"
                  class="animate__animated animate__fadeIn"
                >
                  <div class="row">
                    <!-- <div class="col">
                                            <div
                                                class="d-flex align-items-center justify-content-between mb-4"
                                            >
                                                <h5>Programas Sociais</h5>
                                            </div>
                                        </div> -->
                    <div class="col-12">
                      <div
                        class="d-flex align-items-center justify-content-between mb-4"
                      >
                        <div>
                          <button
                            class="btn btn-primary"
                            @click="associar_programa = true"
                          >
                            <i class="fas fa-plus-square" />
                            {{ $t("Cadastrar") }}
                          </button>
                        </div>
                        <div>
                          <div class="input-group mb-3">
                            <b-input
                              :placeholder="$t('Type to search')"
                              class="form-control search-input"
                              type="text"
                              v-model="search"
                              v-on:change="getProgramas"
                              aria-describedby="input-search"
                            />
                            <div class="input-group-append" role="button">
                              <span class="input-group-text" id="input-search"
                                ><i class="fas fa-search search-icon"
                              /></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <load mode="table" v-if="loadingProgramas" />
                    <div class="col-12" v-else>
                      <span>
                        <a
                          v-if="!showName"
                          @click.prevent="mostrarNome"
                          href="#"
                          ><i class="fas fa-eye"></i> Mostrar Nome de
                          Registro</a
                        >
                        <a v-else @click.prevent="ocultarNome" href="#"
                          ><i class="fas fa-eye-slash"></i> Ocultar Nome de
                          Registro</a
                        >
                      </span>
                      <b-table
                        :fields="[
                          {
                            key: 'protocolo',
                            label: $t('Detalhes'),
                          },
                          {
                            key: 'cadastrado',
                            label: $t('Data'),
                          },
                          {
                            key: 'status_nome',
                            label: $t('Status'),
                          },
                          {
                            key: 'actions',
                            label: '',
                            class: 'text-right',
                            thStyle: {
                              width: '95px',
                              minWidth: '95px',
                            },
                          },
                        ]"
                        :items="itensList"
                        :responsive="true"
                        striped
                        hover
                        show-empty
                        small
                        outlined
                        stacked="md"
                        table-class="mb-3"
                      >
                        <template v-slot:cell(protocolo)="data">
                          Programa:<br />
                          <b>{{ data.item.programa.nome }}</b>
                          <br />
                          Valor:
                          <b>R$ {{ data.item.valor }}</b>
                          <br />
                          Beneficiário(s):<br />
                          <ul>
                            <li
                              v-for="pessoa in data.item.pessoas_objetos"
                              :key="pessoa.id"
                            >
                              <b v-if="!pessoa.nome_social">
                                {{ pessoa.nome_completo }}
                              </b>
                              <b v-else>
                                {{ pessoa.nome_social }} ( N.R.: )
                                <span v-if="showName">{{
                                  pessoa.nome_completo
                                }}</span>
                              </b>
                            </li>
                          </ul>
                          <span v-if="data.item.unidade">
                            Unidade:
                            <b v-if="data.item.unidade">{{
                              data.item.unidade.nome
                            }}</b>
                            <br />
                            Técnico autor: 
                            <b>{{ data.item.autor }}</b>
                          </span>
                        </template>
                        <template v-slot:cell(cadastrado)="data">
                          {{ data.item.cadastrado }}
                        </template>
                        <template v-slot:cell(status_nome)="data">
                          <span
                            class="small"
                            v-html="data.item.status_nome"
                          ></span>
                        </template>
                        <template v-slot:cell()="data">
                          <b-button
                            :to="
                              '/dashboard/programassociais/concessao/' +
                              data.item.id +
                              '/edit?rotaanterior=familia&familia_id=' +
                              data.item.familia_id
                            "
                            class="px-2 mb-0"
                            size="xs"
                            type="button"
                            v-b-tooltip.hover
                            variant="success"
                          >
                            <i class="mdi mdi-square-edit-outline" />
                          </b-button>
                        </template>
                        <template v-slot:empty="scope">
                          <div class="text-center my-5">
                            <img
                              :alt="$t('No results')"
                              class="mb-5"
                              src="/img/icons/robot.svg"
                              style="max-height: 165px"
                            />
                            <h3 class="bold">
                              {{ $t("No records found") }}
                            </h3>
                          </div>
                        </template>
                      </b-table>

                      <div class="row align-items-center">
                        <div class="col-lg-6 col-md-12">
                          <div class="form-group d-inline-flex mb-0">
                            <select
                              class="form-control"
                              style="width: 70px"
                              v-model="perPage"
                              v-on:change="getProgramas"
                            >
                              <option value="5">5</option>
                              <option value="10">10</option>
                              <option value="25">25</option>
                              <option value="50">50</option>
                            </select>
                          </div>
                          <div class="d-inline-flex ml-2">
                            <b-pagination
                              :per-page="perPage"
                              :total-rows="pagination.total"
                              @change="changePage"
                              v-model="page"
                            />
                          </div>
                        </div>
                        <div class="col-lg-6 col-md-12 mt-4 mt-lg-0">
                          <div class="float-lg-right">
                            {{ $t("Showing page") }}
                            {{ pagination.currentPage }}
                            {{ $t("of") }}
                            {{ pagination.totalPages }}
                            {{ $t("pages in") }}
                            {{ pagination.total }}
                            {{ $t("records") }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <Add
                  v-else
                  :familia="familia"
                  @voltar="associar_programa = false"
                  @reload="getProgramas"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Add from "./Add";
export default {
  name: "ReadProgramasFamilia",
  components: {
    Add,
  },
  data() {
    return {
      showName: false,
      search: "",
      loading: true,
      loadingProgramas: true,
      familia: {},
      associar_programa: false,
      page: 1,
      perPage: 10,
      pagination: {
        currentPage: 0,
        perPage: 0,
        total: 0,
        totalPages: 0,
      },
    };
  },
  mounted() {
    this.$route.query.familia_id = this.$route.params.id;
    if (typeof this.$route.query.item === "object") {
      this.familia = this.$route.query.item;
    } else {
      this.getFamilia();
    }
    this.getProgramas();
  },
  methods: {
    mostrarNome() {
      this.showName = true;
    },
    ocultarNome() {
      this.showName = false;
    },
    getProgramas() {
      axios
        .get("api/dashboard/programasocial/beneficiarios", {
          params: {
            id: this.$route.params.id,
            page: this.page,
            search: this.search,
            perPage: this.perPage,
          },
        })
        .then((response) => {
          this.user_id = this.$store.state.user.id;
          this.itensList = response.data.data;
          this.pagination = response.data.pagination;

          if (this.pagination.totalPages < this.pagination.currentPage) {
            this.page = this.pagination.totalPages;
            this.getProgramas();
          } else {
            this.loading = false;
            this.loadingProgramas = false;
          }
        })
        .catch(() => {
          this.loading = false;
          this.loadingProgramas = false;
        });
    },
    changePage(page) {
      if (
        page > 0 &&
        page <= this.pagination.totalPages &&
        page !== this.page
      ) {
        this.page = page;
        this.getProgramas();
      }
    },
    getFamilia() {
      axios
        .get("api/dashboard/familias/" + this.$route.params.id)
        .then((response) => {
          this.familia = response.data.data;
          this.$route.query.familia_id = this.familia.id;
          this.loading = false;
        })
        .catch(() => {
          this.$router.push("/dashboard/familias");
        });
    },
  },
};
</script>

<style></style>
